import { cn } from "@/lib/utils";

/** Fixed app sidebar widths — must match `AppSidebar` (`w-[240px]` / `w-[64px]`). */
export const APP_SIDEBAR_WIDTH_EXPANDED_PX = 240;
export const APP_SIDEBAR_WIDTH_COLLAPSED_PX = 64;

/**
 * Main content column beside the fixed sidebar. Uses explicit width (not `flex-1`) so the
 * column never extends past the viewport when `margin-left` clears the sidebar.
 */
export function appLayoutMainColumnClassName(sidebarCollapsed: boolean): string {
  return cn(
    "flex min-w-0 flex-col transition-[margin,width] duration-200",
    sidebarCollapsed
      ? "ml-[64px] w-[calc(100%-64px)]"
      : "ml-[240px] w-[calc(100%-240px)]",
  );
}
